import React from 'react';
import EditDrawer from './EditDrawer';
import Field from '../../Field';
import { Radio } from '../../FormControls';
import { STUDENT_TEXT_MAX } from '../../../domain/people';
// One list, in columns.js, shared with the wizard's select and the list's
// filter, in MMS's Edit Student drawer's order (#177).
import { STATUSES, STATUS_LABELS } from '../columns';
import s from './editStudent.module.css';
import { DateInput } from '../../RegionInputs';

// Drawer 1 of five — the pencil on the profile card (#120).
//
// It repairs what a teacher got wrong at intake: the names, the status and the
// type, with the `maxLength`s of firestore.rules' student bounds (#121).
//
// Fields and their order are MMS's, less four of its rows: the avatar and its
// `+ Add` button and FaceTime ID, neither of which is a field on our document,
// and Email Address and Mobile Number with SMS Capable — a student is not a
// message destination (#792), and a family contact carries the address and
// the number.


export default function EditStudentDrawer({ open, form, errors, saving, onChange, onClose, onSave }) {
  if (!open) return null;

  return (
    <EditDrawer open title="Edit Student" saving={saving} onClose={onClose} onSave={onSave}>
      {/* Setting a student Inactive is how MMS retires one — there is no
          archive, and delete is reached only from the list. Saving this does
          not prompt and touches neither their future lessons nor the family's
          balance; the student stops matching the list's Active filter (#120). */}
      <div className={s.groupLabel}>Student Status</div>
      <div className={s.radioRow}>
        {STATUSES.map((value) => (
          <Radio
            key={value} name="edit-status" label={STATUS_LABELS[value]}
            checked={form.status === value}
            onChange={() => onChange('status', value)}
          />
        ))}
      </div>

      <div className={s.groupLabelSpaced}>Student Type</div>
      <div className={s.radioRow}>
        <Radio
          name="edit-stype" label="Adult"
          checked={form.studentType === 'adult'}
          onChange={() => onChange('studentType', 'adult')}
        />
        <Radio
          name="edit-stype" label="Child"
          checked={form.studentType === 'child'}
          onChange={() => onChange('studentType', 'child')}
        />
      </div>

      <div className={s.pair}>
        <Field label="First Name" htmlFor="edit-first-name" required error={errors.firstName}>
          <input
            id="edit-first-name" className={s.input} maxLength={STUDENT_TEXT_MAX.firstName}
            value={form.firstName} onChange={(e) => onChange('firstName', e.target.value)}
          />
        </Field>
        <Field label="Last Name" htmlFor="edit-last-name" required error={errors.lastName}>
          <input
            id="edit-last-name" className={s.input} maxLength={STUDENT_TEXT_MAX.lastName}
            value={form.lastName} onChange={(e) => onChange('lastName', e.target.value)}
          />
        </Field>
      </div>

      {/* Free text, as MMS's Gender field is a plain input with a maxlength and
          no options: an enum would be a guess at a vocabulary nothing here
          manages (#120). */}
      <div className={s.pair}>
        <Field label="Gender" htmlFor="edit-gender" hint="Optional">
          <input
            id="edit-gender" className={s.input} maxLength={STUDENT_TEXT_MAX.gender}
            value={form.gender} onChange={(e) => onChange('gender', e.target.value)}
          />
        </Field>
        <Field label="Birthday" htmlFor="edit-birthday" hint="Optional">
          <DateInput
            id="edit-birthday" className={s.input}
            value={form.birthday} onChange={(e) => onChange('birthday', e.target.value)}
          />
        </Field>
      </div>

    </EditDrawer>
  );
}
